export default __webpack_public_path__ + "static/media/spacers.47385ffa.png";